// site loader: once per tab session

const LOADER_STORAGE_KEY = "nf-loader-seen";
const LOADER_SEQUENCE_MS = 2050;
const LOADER_FADE_MS = 600;

if (sessionStorage.getItem(LOADER_STORAGE_KEY)) {
  document.documentElement.classList.add("loader-seen");
} else {
  document.documentElement.classList.add("loader-active");
}

const pathsMatch = (left, right) =>
  left.replace(/\/$/, "") === right.replace(/\/$/, "");

const replayLoaderOnHome = (event) => {
  const homeLink = event.target.closest("[data-home-loader]");
  if (!homeLink || event.defaultPrevented) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (typeof event.button === "number" && event.button !== 0) return;

  sessionStorage.removeItem(LOADER_STORAGE_KEY);

  const nextPath = new URL(homeLink.href, window.location.href).pathname;
  if (!pathsMatch(nextPath, window.location.pathname)) return;

  event.preventDefault();
  window.location.reload();
};

document.addEventListener("click", replayLoaderOnHome);

const dismissLoader = (loader) => {
  if (loader.dataset.dismissing === "true") return;
  loader.dataset.dismissing = "true";

  sessionStorage.setItem(LOADER_STORAGE_KEY, "1");
  loader.classList.add("is-fading");

  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    document.documentElement.classList.remove("loader-active");
    document.documentElement.classList.add("loader-seen");
    loader.remove();
  };

  loader.addEventListener(
    "transitionend",
    (event) => {
      if (event.propertyName !== "opacity") return;
      finish();
    },
    { once: true },
  );
  setTimeout(finish, LOADER_FADE_MS + 100);
};

const initLoader = () => {
  const loader = document.querySelector("[data-loader]");
  if (!loader) return;

  if (sessionStorage.getItem(LOADER_STORAGE_KEY)) {
    document.documentElement.classList.remove("loader-active");
    document.documentElement.classList.add("loader-seen");
    loader.remove();
    return;
  }

  const media = loader.querySelector("[data-loader-media]");
  let started = false;

  const startSequence = () => {
    if (started) return;
    started = true;
    setTimeout(() => dismissLoader(loader), LOADER_SEQUENCE_MS);
  };

  if (media && !media.complete) {
    media.addEventListener("load", startSequence, { once: true });
    media.addEventListener("error", startSequence, { once: true });
    setTimeout(startSequence, LOADER_SEQUENCE_MS + 2000);
    return;
  }

  startSequence();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLoader);
} else {
  initLoader();
}
